import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    "@keyframes rotate": {
      "0%": {
        transform: "rotate(0)",
      },
      "100%": {
        transform: "rotate(360deg)",
      },
    },
    buttonClose: {
      position: "absolute",
      right: 0,
      top: 0,
      marginRight: 2,
      marginTop: 2,
      transform: "translate(50%, -50%)",
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.common.white,
      padding: 4,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
        "& span": {
          animationName: "$rotate",
          animationDirection: "normal",
          animationDuration: "1s",
          animationIterationCount: 1,
        },
      },
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(36),
      },
    },
  }),
  { name: "SpinningCloseButton" },
);
